import { connect } from 'react-redux';
import { withQueues } from 'hocs';
import { notificationActions } from '../../../notifications/actions/notification';
import { hasFeature } from '../../../shared/featureFlag';
import { QueuesDetailsPage as QueuesDetailsPageImpl, } from '../components/queuesDetailsPage';
const mapStateToProps = (state, ownProps) => ({
    agent: state.settings.profile.profile,
    hasTeamsFeatureFlag: hasFeature(state, 'teams-assigning-teams-to-queues'),
});
const mapDispatchToProps = (dispatch) => ({
    notificationAdd: (payload) => dispatch(notificationActions.notificationAdd(payload)),
});
const QueuesDetailsPageWithQueues = withQueues(QueuesDetailsPageImpl);
const QueuesDetailsPage = connect(mapStateToProps, mapDispatchToProps)(QueuesDetailsPageWithQueues);
export { QueuesDetailsPage };
